module.exports = __webpack_public_path__ + "static/media/completedM.04333663.png";